import { Test } from './types';

export const hasSomaticSets = (test: Test) =>
  test?.sets?.some(s => s.sequenceType === 'somatic');

export const hasGermlineSets = (test: Test) =>
  test?.sets?.some(s => s.sequenceType === 'germline');

export const getAminoAcidField = (accountId?: string) => {
  const isFountainLifeAccount = accountId?.startsWith('fountainlife');
  return isFountainLifeAccount ? 'hgvsAminoAcidChange' : 'aminoAcidChange';
};
